export enum RejectStatus {
  TYPE = 'invalid_file_type',
  SIZE = 'invalid_file_size',
  DUPLICATED_NAME = 'duplicated_file_name',
  DUPLICATED_EXTENSION = 'duplicated_extension',
}
